import { Endpoint } from '../endpoint';
import { LogResponse, LogRequest } from '@business/entities/log';
import { R } from '@core/utils/r';

export function fetchLogs(params: LogRequest) {
  return Endpoint.get<LogResponse[]>('@gc/logs', { params: R.objectCompact(params) });
}
